import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { transition, animate, style, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import {
    DashboardImplementCondition
} from '../dashboard/fecr-dashboard.model';
import { FECRDashboardSearch, FECRDashboradImplementVM } from '../fecr-search-panel/fecr-search-panel.model'
import { ImplementRebuildService } from '../../fecr-implement-rebuild-details/implement-rebuild.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-fecr-implment-search-result',
  templateUrl: './fecr-implment-search-result.component.html',
  styleUrls: ['./fecr-implment-search-result.component.scss'],
  animations: [
    trigger(
        'fadeInOut', [
        transition(':enter', [
            style({ opacity: 0 }),
            animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
            style({ opacity: 0 }),
            animate('0ms', style({ opacity: 0 }))
        ])
    ]
    )]
})
export class FecrImplmentSearchResultComponent implements OnInit {

  // Search Parameters
  @Input() searchParameters: FECRDashboardSearch = new FECRDashboardSearch();

  // Equipment Type / Family
  @Input() familyId: number = 0;

  // Favourite Id
  @Input() favouriteId: number = 0;

  // Favourite Name
  favouriteName: string = "";

  // Default View
  defaultView: number = 2;

  // Indicate whether cracks are present
  hasCracks: boolean = false;

  // Paginator
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // The list of 'core' columns to be displayed for equipment.
  displayedColumns = [
    'Implement Type', 'Family', 'Model', 'Start Date', 'Time in Repair', '% Complete', 'Status', 'Total Hours', 'Total Cost', 'SOW Approval Required'
  ];

  // The dynamically generated list of columns and details for implements.
  detailsArray: Array<Array<string | number | DashboardImplementCondition[]>>;
  detailsArrayEquipment: number[] = [];

  columns = [];
  dataSource: any;
  loading: boolean = false;

  ImplementDetalisList:FECRDashboradImplementVM[]=[]
  constructor(public dialog: MatDialog, private _router: Router,
    private _moduleService: ImplementRebuildService, ) {

  }

  ngAfterViewInit() {

  }

  ngOnInit() {
    if (this.searchParameters !== undefined && this.searchParameters != null) {
        //this.loading=true;
           this.loadimp_Overview();
       }
     }
    
  
  loadimp_Overview(){
    this.loading=true;
    var params: FECRDashboardSearch = {
        customers: this.searchParameters.customers,
        jobsites: this.searchParameters.jobsites,
        implementTypes: this.searchParameters.implementTypes,
        repairers: this.searchParameters.repairers,
        models: this.searchParameters.models,
        implements: this.searchParameters.implements,
        status:this.searchParameters.status,
        family:this.searchParameters.family
  };

this._moduleService.GetFECRForDashboardSearch(params).subscribe(result=>{
    console.log("resultimplemnt111", result)
    this.ImplementDetalisList=result;
    this.loading=false;
    })
  }
  initDisplayedColumns() {
      var itemCount = 0;
      this.displayedColumns.forEach(dcName => {
          this.columns.push({
              columnDef: dcName,
              header: dcName,
              item: itemCount,
              isCore: 1,
              cell: (element: any, i: number) => `${element[i]}`
          });
          itemCount++;
      });

      return itemCount;
  }

  getRequiredColour(reqi:boolean,resp:boolean){
    if(reqi==true && resp==null){
        return 'bushClass-X';
    }else{
      return 'bushClass-U';
    }
  }
  getApprovalColour(reqi:boolean,resp:boolean){
    if(reqi==true && resp==null){
        return 'bushClass-U';
    }else if(reqi==true && resp==false){
      return 'bushClass-X';
    }else if(reqi==true && resp==true){
      return 'bushClass-A';
    }else{
      return 'bushClass-U';
    }
  }
 openImplementDetails(id) {
    //this._router.navigate(['implementdetails/', id]).then(result => { window.open( '_blank'); });
   // window.open('/fecr/ImplementRebuildDetails/' + id, '_blank');
    //this._router.navigate(['fecr/implementrebuilddetails/', id]);

    this._router.navigate([]).then(result => {  window.open('/fecr/ImplementRebuildDetails/' + id, '_blank'); });
   
}
  // initDataSource(itemCount: number) {

  //     var params: DashboardSearchFilter = {
  //         Customers: [],
  //         Jobsites: [],
  //         Equipment: [],
  //         Families: [],
  //         Makes: [],
  //         Models: [],
  //         Implements: [],
  //         NoImplemets:false
  //     };

  //     var params3: SaveFavouritesParams;

  //     this._favouritesService.LoadFavouriteDetails(this.favouriteId).subscribe(r => {
  //         if (r != null) {
  //             params3 = r;

  //             params.Customers = params3.Customers;
  //             params.Jobsites = params3.Jobsites;
  //             params.Families = params3.Families;
  //             params.Makes = params3.Makes;
  //             params.Models = params3.Models;

  //             this.defaultView = params3.DefaultView;
  //             this.favouriteName = params3.FavouriteName;

  //             this._dashboardService.GetEquipmentForDashboardFavourite(this.favouriteId).subscribe(result => {
  //                 if (result != null) {
  //                     this.detailsArray = result.Details.map(m => {
  //                         return m.EquipmentRow
  //                     });
  //                     this.detailsArrayEquipment = result.Details.map(m2 => {
  //                         return m2.EquipmentId
  //                     });

  //                     this._dashboardService.GetImplementTypesAvailable(params, this.favouriteId).subscribe(r2 => {
  //                         if (r2) {

  //                             this._dashboardService.GetImplementConditionForDashboard(this.favouriteId).subscribe(dashCond => {
  //                                 if (dashCond != null) {

  //                                     var i: number = 0;
  //                                     var j: number = 0;
  //                                     this.hasCracks = dashCond.CracksPresent;

  //                                     // Loop for each equipment row
  //                                     dashCond.ImplementCondition.forEach(c1 => {

  //                                         // Loop for each implement type column
  //                                         c1.forEach(c2 => {

  //                                             this.detailsArray[i] = this.detailsArray[i].concat([c2]);
  //                                             j++;
  //                                         });

  //                                         i++;
  //                                     });

  //                                     var dataArray = [];
  //                                     dataArray = r2;
  //                                     dataArray.forEach(f => {
  //                                         var x = {
  //                                             columnDef: f.Name + ":" + f.Id,
  //                                             header: f.Name,
  //                                             item: itemCount,
  //                                             isCore: 0,
  //                                             cell: (element: any, i: number) => `${element[i]}`
  //                                         };
  //                                         this.columns.push(x);
  //                                         itemCount++;
  //                                     });

  //                                     this.displayedColumns = this.columns.map(c => c.columnDef);
  //                                     console.log("detailsArray_!", this.detailsArray)
  //                                     this.dataSource = new MatTableDataSource(this.detailsArray);
  //                                     this.dataSource.paginator = this.paginator;
  //                                     this.loading = false;

  //                                 }
  //                             });
  //                         }
  //                     });
  //                 }
  //             });
  //         }
  //     });

  // }

  // getEvalClass(implementCondition: DashboardImplementCondition) {
  //     var evalClass: string = '';
  //     var evalcode: string = implementCondition.EvalCode;

  //     if (this.favouriteId == 0) {
  //         if (evalcode == 'A' && this.searchParameters.evalA) {
  //             evalClass = 'WornPctCell evalColorA';
  //         } else if (evalcode == 'B' && this.searchParameters.evalB) {
  //             evalClass = 'WornPctCell evalColorB';
  //         } else if (evalcode == 'C' && this.searchParameters.evalC) {
  //             evalClass = 'WornPctCell evalColorC';
  //         } else if (evalcode == 'X' && this.searchParameters.evalX) {
  //             evalClass = 'WornPctCell evalColorX';
  //         } else {
  //             evalClass = 'searchEvalNotSelected';
  //         }
  //     }

  //     else {
  //         if (evalcode == 'A') {
  //             evalClass = 'WornPctCell evalColorA';
  //         } else if (evalcode == 'B') {
  //             evalClass = 'WornPctCell evalColorB';
  //         } else if (evalcode == 'C') {
  //             evalClass = 'WornPctCell evalColorC';
  //         } else if (evalcode == 'X') {
  //             evalClass = 'WornPctCell evalColorX';
  //         }
  //     }

  //     return evalClass;
  // }

  // displayEval(implementCondition: DashboardImplementCondition) {
  //     if (this.defaultView == 1) {
  //         return implementCondition.Cracks.toString() + " / " + implementCondition.TotalOP.toString();
  //     } else if (this.defaultView == 2) {
  //         return implementCondition.EvalCode;
  //     } else if (this.defaultView == 3) {
  //         return implementCondition.WornPct.toString() + "%";
  //     }
  // }

  // openEquipmentDetails(id) {
  //     // this._router.navigate(['equipment/', id]);

  //     const url = this._router.serializeUrl(this._router.createUrlTree(['equipment/' + id]));
  //     window.open(url, '_blank');
  // }

  // OpenFavourite() {
  //     let dialogRef = this.dialog.open(FavouriteDialogComponent, {
  //         disableClose: true,
  //         data: {
  //             favouriteId: this.favouriteId
  //         }
  //     });
  //     dialogRef.afterClosed().subscribe(r => {
  //         if (r.data != null) {

  //         } else {

  //         }
  //     });
  // }
}
